/**
 * Component: Geolaction
 * ------------------------------------------------------------------------------
 * This commopent will direct the user to the correct store based on location
 *
 * @namespace Geolaction
 */

/**
* Export a new accordion instance.
*/
function geoLocation()  {
  /**
  * Instance default settings.
  */
  const settings = {};

  /* Country to Store Configuration */
  const countries = {
    US: { Name: 'USA', Store: 'US' },
    CA: { Name: 'Canada', Store: 'US' },
    GB: { Name: 'United Kingdom', Store: 'UK' },
    FI: { Name: 'Finland', Store: 'UK' },
    DK: { Name: 'Denmark', Store: 'UK' },
    SE: { Name: 'Sweden', Store: 'UK' },
    NO: { Name: 'Norway', Store: 'UK' },
    AL: { Name: 'Albania', Store: 'UK' },
    AD: { Name: 'Andorra', Store: 'UK' },
    AT: { Name: 'Austria', Store: 'UK' },
    BY: { Name: 'Belarus', Store: 'UK' },
    BE: { Name: 'Belgium', Store: 'UK' },
    BA: { Name: 'Bosnia and Herzegovina', Store: 'UK' },
    BG: { Name: 'Bulgaria', Store: 'UK' },
    HR: { Name: 'Croatia', Store: 'UK' },
    CY: { Name: 'Cyprus', Store: 'UK' },
    CZ: { Name: 'Czech Republic', Store: 'UK' },
    EE: { Name: 'Estonia', Store: 'UK' },
    FO: { Name: 'Faroe Islands', Store: 'UK' },
    FR: { Name: 'France', Store: 'UK' },
    DE: { Name: 'Germany', Store: 'UK' },
    GI: { Name: 'Gibraltar', Store: 'UK' },
    GR: { Name: 'Greece', Store: 'UK' },
    HU: { Name: 'Hungary', Store: 'UK' },
    IS: { Name: 'Iceland', Store: 'UK' },
    IE: { Name: 'Ireland', Store: 'UK' },
    IT: { Name: 'Italy', Store: 'UK' },
    LV: { Name: 'Latvia', Store: 'UK' },
    LI: { Name: 'Liechtenstein', Store: 'UK' },
    LT: { Name: 'Lithuania', Store: 'UK' },
    LU: { Name: 'Luxembourg', Store: 'UK' },
    MK: { Name: 'Macedonia', Store: 'UK' },
    MT: { Name: 'Malta', Store: 'UK' },
    MD: { Name: 'Moldova', Store: 'UK' },
    MC: { Name: 'Monaco', Store: 'UK' },
    NL: { Name: 'Netherlands', Store: 'UK' },
    PL: { Name: 'Poland', Store: 'UK' },
    PT: { Name: 'Portugal', Store: 'UK' },
    RO: { Name: 'Romania', Store: 'UK' },
    RU: { Name: 'Russia', Store: 'row' },
    SM: { Name: 'San Marino', Store: 'UK' },
    RS: { Name: 'Serbia', Store: 'UK' },
    SK: { Name: 'Slovakia', Store: 'UK' },
    SI: { Name: 'Slovenia', Store: 'UK' },
    ES: { Name: 'Spain', Store: 'UK' },
    CH: { Name: 'Switzerland', Store: 'UK' },
    UA: { Name: 'Ukraine', Store: 'UK' },
    VA: { Name: 'Vatican city', Store: 'UK' },
    IM: { Name: 'Isle of Man', Store: 'UK' },
    ME: { Name: 'Montenegro', Store: 'UK' },
    GG: { Name: 'Guernsey', Store: 'UK' },
    JE: { Name: 'Jersey', Store: 'UK' },
    AU: { Name: 'Australia', Store: 'UK' },
  };

  /**
  * Initialise component.
  */
  function init() {
    // if (Shopify.theme.role === 'unpublished') {
    //   return false;
    // }

    // $.get("https://ipinfo.io", function(response) {
    // console.log(response.country);
    // }, "jsonp");
    // console.log(`👑 The king is back`)
    // geoip2.country(onSuccess, onError)

    function onSuccess(country) {
      console.log(country);
    }

    function onError(error) {
      console.log(error);
    }

      // const countryCode = country.country.iso_code;

    getLocation();
    setEventListens();
  }

  function setEventListens() {
    document.querySelector('#required-information').addEventListener("change", function(evt) {
      setCartAttribute(evt);
      setButtonState();
    });
  }

  function getLocation() {
    $.ajax({
      url: "https://ipinfo.io/json/",
    }).done(function(data) {
      locationChecker(data);
    })
    // .catch((error) => {
    //   return error;
    // });
  }

  function locationChecker(data) {
    console.log(data);
    if (data !== 'undefined') {
      var country_code = data.country;
      console.log(`You are in: ${country_code}`);
      if (country_code === 'IT' || country_code === 'ES') {
        console.log(data.country_code);
        setRequiredInformation();
        setCorrectLanguage(country_code);
        setButtonState();
      }
    }
  }

  function setRequiredInformation() {
    const requiredContainer = document.querySelector('.required-information-container');

    requiredContainer.classList.add('is-active');
  }

  function setCorrectLanguage(country_code) {
    if (country_code === 'IT') {
      document.querySelector('.required-information__italy').classList.add('is-active');
    } else {
      document.querySelector('.required-information__spain').classList.add('is-active');
    }
  }

  function setButtonState() {
    const requireValue = document.querySelector('#required-information');
    const requiredButton = document.querySelector('.button-required');
    const requiredAdditionalButtons = document.querySelector('.additional-checkout-buttons');
    const returnRequireValue = isEmpty(requireValue.value)
    if (returnRequireValue === false) {
      requiredButton.classList.remove('is-disabled');
      requiredAdditionalButtons.classList.remove('is-disabled');
      requiredButton.disabled = false;
    } else {
      requiredButton.classList.add('is-disabled');
      requiredAdditionalButtons.classList.add('is-disabled');
      requiredButton.disabled = true;
    }
  }

  function isEmpty(value) {
    return (value == null || value.length === 0);
  }


  function setCartAttribute(evt) {
    var note = evt.target.value;
    var headers = new Headers({ 'Content-Type': 'application/json' });

    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ attributes: { 'required-information': note } })
    };

    fetch('/cart/update.js', request);
  }


  /*
  * Expose public interface.
  */
  return Object.freeze({
    init,
  });
};

document.addEventListener("DOMContentLoaded", function(){
  setTimeout(() => {
    geoLocation().init();
  }, 1000);
});
